import styled from "styled-components";

export const PostBody = styled.article`

  &:hover {
    .image-container {
      border-radius: 0;
    }
  }

  &.draft {
    opacity: 0.5;  
  }

  .image-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 75%;
    border-radius: 0.6rem;
    transition: all 0.2s cubic-bezier(0.77, 0, 0.175, 1);
    overflow: hidden;

    img {
      object-fit: cover;
    }
  }

  h2 {
    margin-bottom: 0.5rem;
    margin-top: 0.25rem;
    /* font-family: ${({ theme }) => theme.fonts.primary}; */
    /* font-weight: 600; */
    font-size: 1.2rem;
    line-height: 1.4;
  }

  h2, .subtitle, .description {
    margin-left: 0.5rem;
    margin-right: 0.5rem;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;  
    overflow: hidden;
  }

  .subtitle, .description {
    color: #999;
    font-size: 0.9rem;
    margin-top: 0.25rem;
    line-height: 1.5;

    -webkit-line-clamp: 3;
  }

  .subtitle {
    margin-top: 1rem;
    font-size: 0.7rem;
    color: #333;
  }

  a {
    color: black;
    text-decoration: none;
  }
`